export default __webpack_public_path__ + "static/media/womenadd.86ed1191.jpg";